
const mixins = {
    data(){
        return{
            
        }
    },
    // 页面激活时
    activated(){
        // 监听（绑定）滚轮滚动事件
        window.addEventListener('scroll', this.handleScroll, true); 
    },
    deactivated(){
        //  离开页面清除（移除）滚轮滚动事件
        window.removeEventListener('scroll', this.handleScroll,true); 
    },
    // 销毁时移除事件
    destroyed () {
        //  离开页面清除（移除）滚轮滚动事件
        window.removeEventListener('scroll', this.handleScroll,true); 
    },
    methods: {
        // 记录滚动距离
        handleScroll () {
            this.$route.meta.y = window.pageYOffset
        },
    },
}

export default mixins;

